import PropTypes from "prop-types";

/**
 * contexts
 */
import context from "./context";

/**
 * components
 */
import Item from "./item";
import Button from "./button";
import Panel from "./panel";

/** ========== */

const Component = ({ multipleOpen, defaultActiveKey, children, ...props }) => {
  // const [active, setActive] = useState(defaultActiveKey);
  // const [active, setActive] = useContext(AccordionContext);
  return (
    <context.Provider value={{ multipleOpen }}>
      <div {...props}>{children}</div>
    </context.Provider>
  );
};

export default Object.assign(Component, {
  Item: Item,
  Button: Button,
  Panel: Panel,
});

Component.propTypes = {
  multipleOpen: PropTypes.bool,
  defaultActiveKey: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Component.defaultProps = {
  multipleOpen: false,
  defaultActiveKey: "",
};

/** ========== */
